export default "__VITE_ASSET__d9eaf4d8__"